// ── i18n del CRM (Fase 0 del frente bilingüe ES/CA, Ann 2026-07-14) ─────────
// react-i18next con namespaces por dominio (hoy: common; la landing, el canal,
// legales, etc. añaden el suyo al extraerse). Añadir un idioma nuevo (EN/FR)
// = soltar su carpeta en locales/ y sumarlo a IDIOMAS — "¡PUM!".
// Detección del idioma (invitado): 1º lo guardado en localStorage, 2º el idioma
// del NAVEGADOR (una visitante con el navegador en catalán ve catalán a la
// primera). El cliente logueado manda con su idioma_preferido de la ficha
// (ver LanguageContext).
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import esCommon from './locales/es/common.json';
import caCommon from './locales/ca/common.json';
import esLanding from './locales/es/landing.json';
import caLanding from './locales/ca/landing.json';
import esMenu from './locales/es/menu.json';
import caMenu from './locales/ca/menu.json';
import esMiperfil from './locales/es/miperfil.json';
import caMiperfil from './locales/ca/miperfil.json';
import esGestor from './locales/es/gestor.json';
import caGestor from './locales/ca/gestor.json';
import esCanal from './locales/es/canal.json';
import caCanal from './locales/ca/canal.json';
import esAuth from './locales/es/auth.json';
import caAuth from './locales/ca/auth.json';

export const IDIOMAS = ['es', 'ca'];
export const IDIOMA_STORAGE_KEY = 'idioma_preferido';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { common: esCommon, landing: esLanding, menu: esMenu, miperfil: esMiperfil, gestor: esGestor, canal: esCanal, auth: esAuth },
      ca: { common: caCommon, landing: caLanding, menu: caMenu, miperfil: caMiperfil, gestor: caGestor, canal: caCanal, auth: caAuth },
    },
    supportedLngs: IDIOMAS,
    nonExplicitSupportedLngs: true, // 'ca-ES' del navegador → 'ca'
    fallbackLng: 'es', // clave sin traducir → cae al español, nunca a la clave pelada
    defaultNS: 'common',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: IDIOMA_STORAGE_KEY,
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false }, // React ya escapa
    returnEmptyString: false,
  });

export default i18n;
